import type { RootState } from "../store";

export function selectUnreadNotifications(state: RootState) {
  return (state.notifications?.notifications || [])
    .filter(notification => !notification.read_at)
    .filter(notification => notification.membership_id == state.membership?.membershipId)
}
